import { Currency, DistanceMetrics } from 'src/types'

export const CURRENCIES = Object.keys(Currency) as (keyof typeof Currency)[]

export const DISTANCE_METRICS = Object.keys(
  DistanceMetrics,
) as (keyof typeof DistanceMetrics)[]
